/**
 * MASTER WISHLIST FIX
 * - Duplicate fix
 * - Accurate count
 * - Stable grid
 * - No fake empty state
 */

class dT_WhistList {

    constructor() {
        this.KEY = 'shopify-wishlist';
        this.DELIMITER = ',';
    }

    /* =========================
       MARKET SUPPORT
    ========================= */

    getMarketPrefix() {
        const path = window.location.pathname;

        if (path.startsWith('/en-ca')) return '/en-ca';
        if (path.startsWith('/en-us')) return '/en-us';

        return '';
    }

    buildProductUrl(handle) {
        const prefix = this.getMarketPrefix();
        return prefix ? `${prefix}/products/${handle}` : `/products/${handle}`;
    }

    buildWishlistUrl() {
        const prefix = this.getMarketPrefix();
        return prefix ? `${prefix}/pages/wishlist` : `/pages/wishlist`;
    }

    /* =========================
       STORAGE (🔥 FIX DUPLICATES)
    ========================= */
  getWishlist() {
      const data = localStorage.getItem(this.KEY);

      if (!data) return [];

      return [...new Set(
          data
              .split(this.DELIMITER)
              .map(h => h.trim())
              .filter(h => h && h !== 'undefined' && h !== 'null')
      )];
  }

    setWishlist(list) {

        // 🔥 ENSURE NO DUPLICATES SAVED
        list = [...new Set(list)];

        if (!list.length) {
            localStorage.removeItem(this.KEY);
        } else {
            localStorage.setItem(this.KEY, list.join(this.DELIMITER));
        }

        this.syncAll();

        return list;
    }

    updateWishlist(handle) {

        let list = this.getWishlist();

        if (list.includes(handle)) {
            list = list.filter(h => h !== handle);
        } else {
            list.push(handle);
        }

        return this.setWishlist(list);
    }

    removeItem(handle) {
        return this.setWishlist(
            this.getWishlist().filter(h => h !== handle)
        );
    }

    isAdded(handle) {
        return this.getWishlist().includes(handle);
    }

    getKey(handle, variantId) {
        return variantId ? `${handle}--${variantId}` : handle;
    }

    /* =========================
       🔥 FIXED COUNT (NO FAKE 2)
    ========================= */

    count() {
        return this.getWishlist().length;
    }

    /* =========================
       SYNC ENGINE
    ========================= */

    syncAll() {
        this.syncHeader();
        this.syncButtons();
    }

    syncHeader() {

        const count = this.count();

        document.querySelectorAll('dtx-wish-count').forEach(el => {
            const span = el.querySelector('span');
            if (span) span.innerText = count;
        });
    }

    syncButtons() {

        document.querySelectorAll('dtx-wishlist').forEach(el => {

            const btn = el.querySelector('.add-wishlist');
            const handle = btn?.dataset.product_handle;
            const variantId = btn?.dataset.variant_id;

            if (!btn || !handle) return;

            const key = this.getKey(handle, variantId);

            if (this.isAdded(key)) {
                btn.classList.add('added');
            } else {
                btn.classList.remove('added');
            }
        });
    }
}

/* =========================
   HEADER COUNT FIX
========================= */

class dTXWishCount extends HTMLElement {

    constructor() {
        super();
        this.list = new dT_WhistList();
    }

   connectedCallback() {
      setTimeout(() => {
          this.render();
      }, 0);
  }

    render() {
        const span = this.querySelector('span');
        if (span) span.innerText = this.list.count();
    }
}

/* =========================
   BUTTON FIX
========================= */

class dTXWhishList extends HTMLElement {

    constructor() {
        super();

        this.list = new dT_WhistList();

        this.btn = this.querySelector('.add-wishlist');

        this.handle = this.btn?.dataset.product_handle;

        if (!this.btn || !this.handle) return;

        this.btn.addEventListener('click', (e) => {
            e.preventDefault();
            const variantId = this.btn.dataset.variant_id;
            const key = this.list.getKey(this.handle, variantId);
            this.list.updateWishlist(key);
        });
    }

    connectedCallback() {
        this.sync();
    }

    sync() {
        const variantId = this.btn?.dataset.variant_id;
        const key = this.list.getKey(this.handle, variantId);
        if (this.list.isAdded(key)) {
            this.btn.classList.add('added');
        } else {
            this.btn.classList.remove('added');
        }
    }
}

/* =========================
   GRID FIX (NO EMPTY BUG)
========================= */

class dTXWhishListGrid extends HTMLElement {

    connectedCallback() {
        this.list = new dT_WhistList();
        this.load();
    }

    load() {

        const wishlist = this.list.getWishlist();

        if (!wishlist.length) {
            this.render([]);
            return;
        }

        const marketPrefix = this.list.getMarketPrefix();

        const requests = wishlist.map(wishKey => {
            const parts = wishKey.split('--');
            const handle = parts[0];
            const variantId = parts[1] ? parseInt(parts[1]) : null;
            return fetch(`${marketPrefix}/products/${handle}.js`)
                .then(res => res.ok ? res.json() : null)
                .then(product => {
                    if (!product) return null;
                    let variant = variantId
                        ? product.variants.find(v => v.id === variantId)
                        : product.variants[0];
                    if (!variant) variant = product.variants[0];
                    const image = (variant.featured_image && variant.featured_image.src)
                        ? variant.featured_image.src
                        : product.featured_image || '';
                    const price = (variant.price / 100).toFixed(2);
                    const currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'CAD';
                    return {
                        title: product.title,
                        variantTitle: variant.title !== 'Default Title' ? variant.title : '',
                        handle: handle,
                        wishKey: wishKey,
                        image: image,
                        price: `${currency} $${price}`,
                        url: `${this.list.buildProductUrl(handle)}?variant=${variant.id}`
                    };
                })
                .catch(() => null);
        });

        Promise.all(requests).then(responses => {

            const result = responses.filter(Boolean);
            this.render(result);
        });
    }

    render(items) {

        const tbody = this.querySelector('tbody');
        if (!tbody) return;

        tbody.innerHTML = '';

       // 🔥 FIX: only show empty if REAL empty
        if (!items || items.length === 0) {

            const table = this.querySelector('.dtx-table');
            const empty = this.querySelector('.dtx-grid-empty');

            if (table) table.style.display = 'none';
            if (empty) empty.style.display = 'block';

            return;
        }

        items.forEach(item => {

            const tr = document.createElement('tr');

            tr.innerHTML = `
                <td>
                    <a href="${item.url}">
                        <img src="${item.image}" width="80">
                    </a>
                </td>

                <td>
                    <a href="${item.url}">
                        ${item.title}${item.variantTitle ? ' — ' + item.variantTitle : ''}
                    </a>
                </td>

                <td>${item.price}</td>

                <td>
                    <a href="${item.url}">View</a>
                </td>

                <td>
                    <dtx-remove-wish-item>
                        <a href="javascript:void(0);" data-product_handle="${item.wishKey || item.handle}" class="remove-item">
                            Remove
                        </a>
                    </dtx-remove-wish-item>
                </td>
            `;

            tbody.appendChild(tr);
        });
    }
}

/* =========================
   REMOVE FIX
========================= */

class dTXRemoveWishItem extends HTMLElement {

    constructor() {
        super();

        this.btn = this.querySelector('.remove-item');
        this.list = new dT_WhistList();

        this.btn.addEventListener('click', (e) => {
            e.preventDefault();

            const handle = this.btn.dataset.product_handle;

            this.list.removeItem(handle);

            this.closest('tr')?.remove();

            location.reload();
        });
    }
}

/* =========================
   INIT FIX (IMPORTANT)
========================= */

document.addEventListener('DOMContentLoaded', () => {
    const list = new dT_WhistList();

    // small delay ensures storage is ready
    setTimeout(() => {
        list.syncAll();
    }, 50);
});

/* =========================
   REGISTER
========================= */

window.dT_WhistList = dT_WhistList;
customElements.define('dtx-wish-count', dTXWishCount);
customElements.define('dtx-wishlist', dTXWhishList);
customElements.define('dtx-wishlist-grid', dTXWhishListGrid);
customElements.define('dtx-remove-wish-item', dTXRemoveWishItem);


